import React, { ChangeEvent } from 'react'
import { Form } from 'react-bootstrap'
import style from './CustomInput.module.scss'
import classNames from 'classnames'
import { CustomLabel } from './CustomLabel'

interface CustomInputProps {
  className?: any
  placeholder: string
  hideLabel?: boolean
  type: string;
  name: string;
  forceShowLabel?: boolean
  label?: string;
  value: string | number
  disabled?: boolean
  required?: boolean
  onChange: (e: ChangeEvent<any>) => void
}
export const CustomInput = (props: CustomInputProps) => {
  return (
    <div>
      {
        props?.label &&
        <CustomLabel show={props.forceShowLabel ? true : props.value && !props.hideLabel ? true : false} label={props?.label} />
      }
      <Form.Control
        className={classNames(style.cardInputStyle, props.className)}
        placeholder={props.placeholder}
        type={props.type}
        name={props.name}
        value={props.value}
        required
        disabled={props.disabled}
        onChange={props.onChange}
      />
    </div>

  )
}
